"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _core = require("@lingui/core");

var _ToggleSnoozed = _interopRequireDefault(require("../../../containers/ToggleSnoozed"));

var _utils = require("../utils");

var _options = require("../utils/options");

var _analysis = require("../../../context/analysis");

var _Exporter = require("../../Exporter");

var _store = require("../../../redux/store");

/* eslint-disable no-eq-null */
const StyledThirds = (0, _styledComponents.default)(_blocks.Thirds)`
  margin-bottom: ${_blocks.spacing.default};
`;

const ToolBar = ({
  searchData,
  snoozedCount,
  currentGroup,
  currentSort,
  timeRange,
  expandAll,
  onExpand,
  onSearch,
  searchSessionKey,
  onTimeRangeChange,
  onGroupChange,
  onSortChange,
  initialSearch,
  exportRawData
}) => {
  const {
    viewMode
  } = (0, _analysis.useState)();
  const initial = initialSearch || (0, _utils.getInstantSearchQueryFromUrl)();
  const projects = (0, _store.useAppSelector)(state => {
    var _state$auth$user$port, _state$auth$user, _state$auth$user$port2;

    return Object.values((_state$auth$user$port = (_state$auth$user = state.auth.user) === null || _state$auth$user === void 0 ? void 0 : (_state$auth$user$port2 = _state$auth$user.portfolio) === null || _state$auth$user$port2 === void 0 ? void 0 : _state$auth$user$port2.projects) !== null && _state$auth$user$port !== void 0 ? _state$auth$user$port : {});
  });

  const transformedRawExportData = _react.default.useMemo(() => {
    return exportRawData === null || exportRawData === void 0 ? void 0 : exportRawData.reduce((acc, group) => {
      const transformedGroup = group.reduce((group, item) => {
        const project = projects.find(project => project.project_name === item.project); // Manually override the projectId property to support creating exports with
        // links to HV over Skyspark. This isn't supported by the ComposedInsight
        // shape as there are many places to change that and it's not worth it at this
        // stage in Bonfire's development.
        // @ts-expect-error

        group.push({ ...item,
          projectId: project === null || project === void 0 ? void 0 : project.project_pk
        });
        return group;
      }, []);
      acc.push(transformedGroup);
      return acc;
    }, []);
  }, [exportRawData]); // * If there's no initial search query, set filtered to all


  _react.default.useEffect(() => {
    if (!initial) {
      onSearch({
        filtered: searchData,
        query: ''
      });
    }
  }, []);

  return /*#__PURE__*/_react.default.createElement(StyledThirds, null, /*#__PURE__*/_react.default.createElement(_blocks.Left, null, /*#__PURE__*/_react.default.createElement(_blocks.ControlGroup, {
    tight: true
  }, /*#__PURE__*/_react.default.createElement(_blocks.Button, {
    icon: expandAll ? /*#__PURE__*/_react.default.createElement(_blocks.Collapse, {
      small: true
    }) : /*#__PURE__*/_react.default.createElement(_blocks.Expand, {
      small: true
    }),
    appearance: "outline",
    thin: true,
    onClick: onExpand
  }, expandAll ? `Collapse All` : `Expand All`), exportRawData != null && /*#__PURE__*/_react.default.createElement(_Exporter.Exporter, {
    "data-cy": "export-all-insights",
    appearance: "outline",
    rawData: transformedRawExportData,
    fileName: "All-Insights.csv",
    dataFormatter: _utils.getAllInsightsExportData,
    exportType: "insight"
  }, "Export"))), /*#__PURE__*/_react.default.createElement(_blocks.Center, null, /*#__PURE__*/_react.default.createElement(_blocks.Search, {
    sessionKey: searchSessionKey,
    initial: initial,
    data: searchData,
    onSearch: onSearch,
    defaultField: "targetValueString",
    indexId: "occurrenceId"
  })), /*#__PURE__*/_react.default.createElement(_blocks.Right, null, /*#__PURE__*/_react.default.createElement(_blocks.DropdownMenu, {
    right: true,
    trigger: "Group By",
    value: currentGroup,
    onSelect: onGroupChange,
    options: _options.GROUP_BY_OPTIONS[viewMode].map(({
      value,
      label,
      sub
    }) => ({
      value,
      label: label(_core.i18n),
      sub: sub != null ? sub(_core.i18n) : label(_core.i18n)
    }))
  }), /*#__PURE__*/_react.default.createElement(_blocks.DropdownMenu, {
    right: true,
    trigger: "Sort By",
    value: currentSort,
    onSelect: onSortChange,
    options: _options.SORT_BY_OPTIONS[viewMode].map(({
      value,
      label,
      sub
    }) => ({
      value,
      label: label(_core.i18n),
      sub: sub != null ? sub(_core.i18n) : label(_core.i18n)
    }))
  }), /*#__PURE__*/_react.default.createElement(_blocks.DropdownMenu, {
    right: true,
    trigger: "History",
    value: timeRange,
    onSelect: onTimeRangeChange,
    options: _options.TIME_RANGE_OPTIONS[viewMode].map(({
      value,
      label
    }) => ({
      value,
      label: label(_core.i18n)
    }))
  }), /*#__PURE__*/_react.default.createElement(_ToggleSnoozed.default, {
    count: snoozedCount
  })));
};

exports.ToolBar = ToolBar;